import { privateOfficeContractsService } from "@/services/private-office-contracts-service";
import { LoaderFunctionArgs } from "react-router-dom";
import { cancellationReasonOptions } from "@/features/private-room/contracts/list/utils/private-office-contract-mappings";
import { formatInTimeZone } from "date-fns-tz";

export const loader = async ({ params }: LoaderFunctionArgs) => {
  const { contractId } = params;

  if (!contractId) {
    throw new Error("Contract ID is required");
  }

  const contract =
    await privateOfficeContractsService.getPrivateOfficeContractById(
      Number(contractId),
    );

  if (!contract) {
    throw new Error("Private office contract not found");
  }

  const maxDate =
    contract.endDate && formatInTimeZone(contract.endDate, "UTC", "yyyy-MM-dd");

  return {
    contract,
    contractId,
    cancellationReasonOptions,
    maxDate,
  };
};

export type LoaderData = Awaited<ReturnType<typeof loader>>;
